/**
 * Check if the current param is an instance object (No Array, No Date)
 * @returns boolean
 */
function isObject(obj) {
  return (
    obj &&
    typeof obj === 'object' &&
    !Array.isArray(obj) &&
    !(obj instanceof Date)
  );
}

export default isObject;
